import { Injector, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { NgxSpinnerModule } from 'ngx-spinner';
import { UIRouter, UrlParts } from '@uirouter/core';
import { StatesModule, UIRouterModule } from '@uirouter/angular';
import { UIRouterRx } from '@uirouter/rx';
// import { StoreDevtoolsModule } from '@ngrx/store-devtools';
// import { Visualizer } from '@uirouter/visualizer';

import { XmLoginComponentModule } from 'shared/login/module';
import { XmAppComponent } from './app/app';
import { BaseComponent } from './base/base';
import { CoreModule } from 'core/module';
import { XM_ROUTES } from './routes';
import { ParamType } from 'core/constants';

export function handle404Error(_matchValue: boolean, _url: UrlParts, router: UIRouter): void {
    router.stateService.go('404', {}, { location: false });
}

export function configRouter(router: UIRouter, _injector: Injector, module: StatesModule): void {
    router.plugin(UIRouterRx);
    // router.plugin(Visualizer);

    router.urlService.config.type(ParamType.encoded, {
        encode: (val: string) => val && decodeURIComponent(val.toString()),
        decode: (val: string) => val && decodeURIComponent(val.toString()),
        is: (val: string) => typeof val === 'string',
        equals: (a: string, b: string) => a === b
    });

    module.states = XM_ROUTES;
}

@NgModule({
    bootstrap: [ XmAppComponent ],
    declarations: [
        XmAppComponent,
        BaseComponent
    ],
    imports: [
        BrowserAnimationsModule,
        CoreModule,
        XmLoginComponentModule,
        LoadingBarModule,
        NgxSpinnerModule,
        UIRouterModule.forRoot({ states: XM_ROUTES, otherwise: handle404Error, config: configRouter })
        // StoreDevtoolsModule.instrument()
    ]
})
export class XMModule {}